<template>
  <div>
    <v-progress-circular
      v-if="chartStatus.loading && chartOptions.series.length <= 0"
      :indeterminate="true"
      :size="75"
      height="3"
      color="primary"
      class="progress-circular" />
    <v-progress-linear
      v-if="chartStatus.loading && chartOptions.series.length > 0"
      :indeterminate="true"
      height="3"
      color="primary"
      class="progress-card" />
    <template v-if="!chartStatus.noData && chartOptions.xaxis.categories.length > 0">
      <apexchart
        ref="chartCompetitorsCoverage"
        class="competitors-coverage-chart"
        type="bar"
        :height="height"
        :options="chartOptions"
        :series="chartOptions.series" />
    </template>
    <i-no-data v-if="chartStatus.noData" heading="Oops!" />
  </div>
</template>

<script>
export default {
  name: 'chart',
  props: {
    chartOptions: {
      type: [Object, Array],
      default: null
    },
    chartStatus: {
      type: [Object, Array],
      default: null
    },
    height: {
      type: [Number, String],
      default: 440
    },
    columnWidth: {
      type: [Number, String],
      default: null
    },
    brand: {
      type: [Number, String, Array],
      default: 0
    },
    seller: {
      type: [Number, String, Array],
      default: 0
    },
    category: {
      type: [Number, String, Array],
      default: 0
    }
  },
  mounted () {
    this.setColumnWidth()
    if (this.chartOptions.series.length < 1) {
      this.$store.dispatch('analyticsCompetitorsCoverageModule/getChart', {
        brandId: this.brand,
        sellerId: this.seller,
        categoryId: this.category,
        elemRef: this.$refs.chartCompetitorsCoverage,
        elemRefPopup: this.$refs.chartCompetitorsCoveragePopup
      })
    }
  },
  methods: {
    setColumnWidth () {
      if (this.columnWidth) {
        this.$store.commit('analyticsCompetitorsCoverageModule/SET_columnWidth', {width: this.columnWidth})
        if (this.$refs.chartCompetitorsCoverage) {
          this.$refs.chartCompetitorsCoverage.refresh()
        }
      }
    },
    resetColumnWidth () {
      this.$store.commit('analyticsCompetitorsCoverageModule/RESET_columnWidth')
    }
  },
  destroyed () {
    this.resetColumnWidth()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/analytics/competitors-coverage/chart.vue